// 附件列表
const AttachmentList = resolve =>
  require(['@/views/Attachment/list'], resolve)
export default [
  {
    name: 'Attachment_list',
    path: '/Attachment/list',
    component: AttachmentList,
    meta: {
      keepAlive: false,
      title: '附件列表',
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/attachment.js